// STORY SECTION CAROUSEL *****************************************            
                           
  
// init global ***
var sCarTranslateValue;
var sCurrentIndex = 1;
var sMaxIndex = 9;
var sAutoTimer;
var sPauseTimer;




// start slider function ***
function sStartAutoSlide() {
    sStopAutoSlide();
    sAutoTimer = setInterval(function () { sNextSlide(); }, 2500);
}




// stop slider function *** 
function sStopAutoSlide() {
    clearInterval(sAutoTimer);
}




// pause slider function ***
function sPauseAutoSlide(ms) {
    sStopAutoSlide();
    clearTimeout(sPauseTimer);
    sPauseTimer = setTimeout(sStartAutoSlide, ms);
}




// prev slide function *** 
function sPrevSlide(isManual) {
    if (sCurrentIndex > 1) {
        sCurrentIndex--;
        sTransitionCarousel();
    }
    if (isManual) { sPauseAutoSlide(5000); }
}




// next slide function *** 
function sNextSlide(isManual) {
    if (sCurrentIndex === sMaxIndex) {
        sCurrentIndex = 1;
    } 
    else {
        sCurrentIndex++;
    }
    sTransitionCarousel();
    if (isManual) { sPauseAutoSlide(5000); }
}




// click handlers *** 
$(".fhcarcontrol.left").on("click", function () { sPrevSlide(true); });
$(".fhcarcontrol.right").on("click", function () { sNextSlide(true); });




// transition *** 
function sTransitionCarousel() {
    $("#StoryCarInner").css({ "transform": "translate(" + ((sCarTranslateValue * -1) * (sCurrentIndex - 1)) + "px,0px)" }); 
}




// pause on hover ***
$("#StoryCarOuter").on("mouseenter", function () {
    sStopAutoSlide();
    clearTimeout(sPauseTimer); 
}).on("mouseleave", function () {
    sStartAutoSlide();  
});




// set translate value *** 
$(window).on("resize", function () {
    let sCarIndicator = $("#StorySection #StorySectionHeader").css("padding-left");
    if (sCarIndicator === "200px") { sCarTranslateValue = 400; }
    if (sCarIndicator === "100px") { sCarTranslateValue = 400; }
    if (sCarIndicator === "50px") { sCarTranslateValue = 290; }  
}).resize();




// start *** 
sStartAutoSlide(); 







    
 